import { createSelector } from 'reselect';
import { isOnMobileApp, hasEhrId } from '../shared/person-selectors';
export const selectUser = (state) => state.user;
export const selectIsOnMobileApp = createSelector(selectUser, isOnMobileApp);
export const selectHasEhrId = createSelector(selectUser, hasEhrId);
